export enum SingleImportStatus {
    Init = 'INIT',
    InProgress = 'IN_PROGRESS',
    Success = 'SUCCESS',
    Fail = 'FAIL',
    Exists = 'EXISTS',
}

export function getLocalizedSingleImportStatus(): Record<any, string> {
    return {
        INIT: $localize`:@@status.init:Klaar voor uitvoeren`,
        IN_PROGRESS: $localize`:@@status.inProgress:Bezig`,
        SUCCESS: $localize`:@@status.success:Succesvol`,
        FAIL: $localize`:@@status.fail:Gefaald`,
        EXISTS: $localize`:@@status.exists:Niet overschreven`,
    };
}

export const singleImportStatusColorCode: Record<any, string> = {
    INIT: 'text-inherit',
    IN_PROGRESS: 'text-inherit',
    SUCCESS: 'text-success',
    FAIL: 'text-danger',
    EXISTS: 'text-inherit',
};
